import { Table, TableColumnsType } from 'antd';
import { FC, useMemo } from 'react';
import Pagination from '../../common/Pagination';
import { ICacNotViewedStudent } from '../../../models/statistics.model';
import { getCommonCodeLabel } from '../../../lib/store';

interface IProps {
  rows: ICacNotViewedStudent[];
  total?: number;
  pageNo: number;
  setPageNo: (page: number) => void;
  pageSize: number;
  loading?: boolean;
}

const CacNotViewedTable: FC<IProps> = ({
  rows,
  total = 0,
  pageNo,
  setPageNo,
  pageSize,
  loading,
}) => {
  const columns: TableColumnsType<ICacNotViewedStudent> = useMemo(
    () => [
      {
        title: '캠퍼스',
        dataIndex: 'campusKorName',
        key: 'campusKorName',
        align: 'center',
      },
      {
        title: '교육 단계',
        key: 'eduStepCode',
        align: 'center',
        render: (_, row) => getCommonCodeLabel('PR0006', row.eduStepCode, 'ko'),
      },
      {
        title: '학생 이름',
        dataIndex: 'studentName',
        key: 'studentName',
        align: 'center',
      },
      {
        title: '아이디',
        dataIndex: 'webId',
        key: 'webId',
        align: 'center',
      },
      {
        title: '학생코드',
        dataIndex: 'studentCode',
        key: 'studentCode',
        align: 'center',
      },
      {
        title: '단계',
        dataIndex: 'courseName',
        key: 'courseName',
        align: 'center',
      },
      {
        title: '수강반',
        dataIndex: 'className',
        key: 'className',
        align: 'center',
      },
      {
        title: '담임',
        dataIndex: 'homeroomName',
        key: 'homeroomName',
        align: 'center',
      },
    ],
    [],
  );

  return (
    <>
      <div className="comm-table__area" style={{ overflowX: 'auto' }}>
        <Table<ICacNotViewedStudent>
          rowKey={(r) => `${r.campusCode}-${r.studentCode}`}
          columns={columns}
          dataSource={rows}
          pagination={false}
          loading={loading}
        />
      </div>
      {total > 0 && (
        <div className='common-paging center'>
          <Pagination
            page={pageNo}
            setPage={setPageNo}
            total={total}
            pageSize={pageSize}
          />
        </div>
      )}
    </>
  );
};

export default CacNotViewedTable;
